<mat-form-field>

  <mat-label *ngIf="label">{{label | translate}}</mat-label>
  <mat-label *ngIf="!label && placeholder"> {{placeholder | translate}}</mat-label>
  <div class="input">

    <input matInput
           [id]="id"
           [attr.aria-label]="ariaLabel"
           [attr.tabindex]="tabindex"
           [formControl]="form"
           [placeholder]="placeholder | translate"
           [required]="(form | controlRequired) || required"
           [attr.autocomplete]="autocomplete ? autocomplete : null"
           (keydown)="keyDownFn ? keyDownFn($event): null"
           (blur)="blurFn ? blurFn(form): setNullInFormControlIfValueIsBlank()"
           (paste)="pasteFn ? pasteFn($event): null" />

    <div class="input__icon"
         *ngIf="matIconType">
      <mat-hint *ngIf="!form.enabled"
                class="only-for-reader"
                align="start">{{ matIconText | translate }}</mat-hint>
      <tooltip directionH="left"
               [type]="matIconType"
               [icon]="matIconType">{{ matIconText | translate }}</tooltip>
    </div>

    <div class="input__icon"
         *ngIf="showWarn">
      <mat-hint *ngIf="!form.enabled"
                class="only-for-reader"
                align="start">{{ warnMessage | translate }}</mat-hint>
      <tooltip directionH="left"
               type="alert"
               icon="report_problem">{{ warnMessage | translate }}</tooltip>
    </div>
  </div>

  <mat-hint *ngIf="form.enabled"
            align="start">{{hint | translate}}</mat-hint>

  <mat-error>
    {{ form?.errors | formError: refreshPipe }}
  </mat-error>

</mat-form-field>
